jQuery(document).ready(function ($) {
  /* ==================== Fonts ==================== */

  const WebFont = require("webfontloader");

  WebFont.load({
    google: {
      families: ["Montserrat:300,400,600,700,900", "Oswald:200,300,400,700"],
    },
  });
  /* ==================== Menus ==================== */

  const mobileMenuToggle = document.querySelector(".navToggle"),
    mobileMenu = document.getElementById("mobileNav"),
    header = document.querySelector("#header"),
    stickyHeader = document.querySelector("#header.is-sticky"),
    subMenuItems = document.querySelectorAll(".menu-item-has-children"),
    mobileSubMenuItems = document.querySelectorAll(
      "#mobileNav .menu-item-has-children"
    ),
    adminBar = document.getElementById("wpadminbar");

  mobileSubMenuItems.forEach((element) => {
    element.addEventListener("click", toggleSubMenu);
  });

  function toggleSubMenu() {
    this.classList.toggle("active");
  }

  const setHeaderHeight = () => {
    let headerOffset = header.getBoundingClientRect().bottom;
    let adminBarHeight;
    if (adminBar) {
      adminBarHeight = adminBar.offsetHeight;
      // stickyHeader.style.top = `${adminBarHeight}px`;
    } else {
      adminBarHeight = 0;
    }
    if (headerOffset && adminBarHeight !== null) {
      mobileMenu.style.top = `${headerOffset - adminBarHeight}px`;
      mobileMenu.style.minHeight = `calc(100vh - ${headerOffset}px)`;
    }
  };

  // Initialize header and mobile menu height
  setHeaderHeight();

  // Listen for window resizing to update header and mobile menu height as screen size changes
  addEventListener("resize", (event) => {
    setHeaderHeight();
  });

  mobileMenuToggle.addEventListener("click", () => {
    mobileMenuToggle.classList.toggle("is-active");
    mobileMenu.classList.toggle("menu-open");
  });
});

/* ==================== Scrolling Classes ==================== */

let scrollYPos = 0;
const header = document.querySelector("#header"),
  stickyHeader = document.querySelector("#header.is-sticky");

addEventListener("scroll", () => {
  stickyHeader.classList.toggle("sticky-header", window.scrollY > 0);
  header.classList.toggle("scroll-up", window.scrollY < scrollYPos);
  header.classList.toggle("scroll-down", window.scrollY > scrollYPos);

  scrollYPos = window.scrollY;
});

/* ==================== Theme description read more ==================== */

let termDescription = document.querySelector(".term-description");
let termDescriptionGallery = document.querySelector(
  ".term-description .foogallery"
);
let termDescriptionParas = document.querySelectorAll(".term-description p");
if (termDescription) {
  let readMore = document.createElement("p");
  readMore.classList.add("read-more");
  readMore.innerText = "Read more";
  readMore.addEventListener("click", toggleTermDesc);
  termDescription.insertBefore(readMore, termDescriptionGallery);
  if (termDescriptionParas.length > 1) {
    for (let i = 0; i < termDescriptionParas.length; i++) {
      if (i !== 0) {
        termDescriptionParas[i].style.display = "none";
      }
    }
  }

  function toggleTermDesc() {
    if (this.innerText == "READ MORE") {
      this.innerText = "Read less";
    } else {
      this.innerText = "Read more";
    }
    if (termDescriptionParas.length > 1) {
      for (let i = 0; i < termDescriptionParas.length; i++) {
        if (i !== 0) {
          if (termDescriptionParas[i].style.display === "block") {
            termDescriptionParas[i].style.display = "none";
          } else {
            termDescriptionParas[i].style.display = "block";
          }
        }
      }
    }
  }
}
